import { Component } from '@angular/core';

@Component({
  selector: 'site-searchField',
  templateUrl: './searchField.component.html',
  styleUrls: ['./searchField.component.css']
})
export class SearchField {

  isMobileSideMenu: boolean = false;

  private displayMobileSideMenu(): void
  {
    if (this.isMobileSideMenu==false)
    {
      document.getElementById("mobileSideNav").style.width = "250px";
      this.isMobileSideMenu = true;
    }
    else
    {
      document.getElementById("mobileSideNav").style.width = "0px";
      this.isMobileSideMenu = false;
    }
  }

  // shouldRun = [/(^|\.)plnkr\.co$/, /(^|\.)stackblitz\.io$/].some(h => h.test(window.location.host));
}



// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/searchField/searchField.component.ts